import { FC, useMemo } from 'react';
import { Box, Group, Text } from '@mantine/core';
import { Paper } from '../../../paper/Paper';
import styles from './CompositeChartCustomTooltip.module.css';

interface TooltipEntry {
    color?: string;
    dataKey?: string | number;
    value?: number;
}

interface CompositeChartCustomTooltipProps {
    label?: string | number;
    payload?: TooltipEntry[];
}

export const CompositeChartCustomTooltip: FC<CompositeChartCustomTooltipProps> = ({ payload, label }) => {
    const visibleEntries = useMemo(
        () => (payload || []).filter(entry => entry.color !== 'transparent'),
        [payload]
    );
    if (!visibleEntries.length) return null;

    return (
        <Paper>
            <Text className={styles.tooltipLabel}>{label}</Text>
            {visibleEntries.map(item => (
                <Group key={item.dataKey} className={styles.tooltipGroup}>
                    <Box className={styles.tooltipSwatch} style={{ backgroundColor: item.color }} />
                    <Text className={styles.tooltipKey}>{item.dataKey}</Text>
                    <Text className={styles.tooltipValue}> {item.value}</Text>
                </Group>
            ))}
        </Paper>
    );
};
